import { render } from "./legoTableCustom.vue?vue&type=template&id=0665b157&scoped=true"
import script from "./legoTableCustom.vue?vue&type=script&lang=js"
export * from "./legoTableCustom.vue?vue&type=script&lang=js"

import "./legoTableCustom.vue?vue&type=style&index=0&id=0665b157&lang=scss&scoped=true"
import "./legoTableCustom.vue?vue&type=style&index=1&id=0665b157&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0665b157"],['__file',"src/components/lego/extend/legoTableCustom.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0665b157"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0665b157', __exports__)) {
    api.reload('0665b157', __exports__)
  }
  
  module.hot.accept("./legoTableCustom.vue?vue&type=template&id=0665b157&scoped=true", () => {
    api.rerender('0665b157', render)
  })

}


export default __exports__